/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { NgClass } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, inject, Input, OnInit } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { RouterLink } from '@angular/router';
import { TenantId } from '@src/app/model/abstract-object';
import { CreditorsListPageNavRoute } from '@src/app/routes/creditors-list-page';
import { PurchasePageNavRoute } from '@src/app/routes/purchase-page-nav';
import { ChosenWidget, IWidget } from '@src/app/shared/dashboard/DashboardTypes';
import { MessageService } from '@src/app/shared/message.service';
import { NrHelper } from '@src/app/shared/NrHelper';
import { TenantService } from '@src/app/shared/tenant.service';

export class CreditorStats {
    teamId: TenantId;
    creditors: {
        totalCreditors: string; 
        forApproval: string; 
        accruals: string;
        cashAvailable: string;
    }
}
@Component({
    selector: 'app-creditors-widget',
    imports: [RouterLink, MatCardModule, NgClass],
    templateUrl: './creditors-widget.component.html',
    styleUrls: ['../../../../shared/dashboard/hello-world-widget/widget.component.scss']
})
export class CreditorsWidgetComponent implements IWidget, OnInit {
    @Input() chosenWidget: ChosenWidget;

    title = $localize`Creditors`;
    host: ElementRef<Element> = inject(ElementRef);
    options: { name: string; action: () => void; }[];
    http = inject(HttpClient);
    tenantSvc = inject(TenantService);
    msgSvc = inject(MessageService);
    nrHelper = NrHelper;

    routerLink = CreditorsListPageNavRoute.getListRouterLink();
    forApprovalLink = PurchasePageNavRoute.getListRouterLink({_view: 'unpaidUnApproved'});
    accrualLink = PurchasePageNavRoute.getListRouterLink({typeId: '54,55', outstanding: '!=0'});

    data: CreditorStats;

    ngOnInit(): void {
        this.http.get<CreditorStats>(this.tenantSvc.getPath('omc/dashboard/creditors')).subscribe( 
            data => this.data = data,
            error => this.msgSvc.showError(error, 'Request Summary')
        );        
    }
}
